if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				if (this.querySelector("form") !== null) {
					this.form = this.querySelector("form");
					this.form.querySelector('[name="id"]').disabled = false;
					this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				}

				this.cart = document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				if (document.querySelector("cart-drawer"))
					this.submitButton.setAttribute("aria-haspopup", "dialog");

				this.hideErrors = this.dataset.hideErrors === "true";
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute("aria-disabled") === "true") return;

				this.handleErrorMessage();

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");
				this.querySelector(".loading-overlay__spinner")?.classList.remove(
					"hidden"
				);

				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];

				const formData = new FormData(this.form);
				if (this.cart) {
					formData.append(
						"sections",
						this.cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append("sections_url", window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: "product-form",
								productVariantId: formData.get("id"),
								errors: response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							// Shopify may still have partially added items (e.g. requested
							// 3 but only 1 in stock → 1 added with a "due to availability"
							// notice). Re-fetch the cart sections so the drawer reflects
							// what's actually in the cart instead of staying empty until
							// the page is reloaded.
							if (this.cart) {
								const sectionIds = this.cart
									.getSectionsToRender()
									.map((s) => s.id)
									.join(",");
								fetch(
									`${routes.cart_url}.js?sections=${sectionIds}&sections_url=${encodeURIComponent(
										window.location.pathname
									)}`,
									{ headers: { "X-Requested-With": "XMLHttpRequest" } }
								)
									.then((r) => r.json())
									.then((cartData) => {
										if (
											cartData &&
											cartData.item_count > 0 &&
											cartData.sections
										) {
											this.cart.classList.remove("is-empty");
											this.cart.renderContents({
												id: cartData.id,
												sections: cartData.sections,
											});
										}
									})
									.catch((err) => console.error(err));
							}

							const soldOutMessage =
								this.submitButton.querySelector(".sold-out-message");
							if (!soldOutMessage) return;
							this.submitButton.setAttribute("aria-disabled", true);
							this.submitButton.querySelector("span").classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: "product-form",
								productVariantId: formData.get("id"),
							});
						this.error = false;

						const renderCartDrawer = (finalResponse) => {
							const quickAddModal = this.closest("quick-add-modal");
							if (quickAddModal) {
								document.body.addEventListener(
									"modalClosed",
									() => {
										setTimeout(() => {
											this.cart.renderContents(finalResponse);
										});
									},
									{ once: true }
								);
								quickAddModal.hide(true);
							} else {
								this.cart.renderContents(finalResponse);
							}
						};

						const shouldAutoAdd =
							window.autoAddConfig &&
							window.autoAddConfig.autoAddVariantIds.length > 0 &&
							window.autoAddConfig.collectionProductIds.includes(response.product_id);

						if (shouldAutoAdd) {
							this.handleAutoAdd(response).then((finalResponse) => {
								renderCartDrawer(finalResponse);
							});
						} else {
							renderCartDrawer(response);
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						if (this.cart && this.cart.classList.contains("is-empty"))
							this.cart.classList.remove("is-empty");
						if (!this.error) this.submitButton.removeAttribute("aria-disabled");
						this.querySelector(".loading-overlay__spinner")?.classList.add(
							"hidden"
						);
					});
			}

			async handleAutoAdd(originalResponse) {
				try {
					const cartRes = await fetch(`${routes.cart_url}.js`);
					const cartData = await cartRes.json();
					const existingVariantIds = cartData.items.map((item) => item.variant_id);

					const variantsToAdd = window.autoAddConfig.autoAddVariantIds.filter(
						(id) => !existingVariantIds.includes(id)
					);

					if (variantsToAdd.length === 0) return originalResponse;

					const sections = this.cart
						? this.cart.getSectionsToRender().map((s) => s.id)
						: [];

					const addConfig = fetchConfig();
					addConfig.body = JSON.stringify({
						items: variantsToAdd.map((id) => ({ id, quantity: 1 })),
						sections: sections.join(","),
						sections_url: window.location.pathname,
					});

					const addRes = await fetch(`${routes.cart_add_url}`, addConfig);
					const addData = await addRes.json();

					if (addData.status) return originalResponse;

					publish(PUB_SUB_EVENTS.cartUpdate, {
						source: "product-form",
						productVariantId: variantsToAdd[0],
					});

					if (addData.sections) return addData;
					return originalResponse;
				} catch (e) {
					console.error("Auto-add failed:", e);
					return originalResponse;
				}
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}
